import { render } from "./message-input-at.vue?vue&type=template&id=6e1e4c6e&scoped=true&ts=true"
import script from "./message-input-at.vue?vue&type=script&lang=ts"
export * from "./message-input-at.vue?vue&type=script&lang=ts"

import "./message-input-at.vue?vue&type=style&index=0&id=6e1e4c6e&scoped=true&lang=scss"

import exportComponent from "D:\\chat-tx\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1e4c6e"]])

export default __exports__